import api from './api';

// Auth API
export const authAPI = {
    login: (credentials) => api.post('/auth/login', credentials),
    verifyOTP: (data) => api.post('/auth/verify-otp', data),
    register: (userData) => api.post('/auth/register', userData),
    getMe: () => api.get('/auth/me'),
    updateDetails: (data) => api.put('/auth/updatedetails', data),
    updatePassword: (data) => api.put('/auth/updatepassword', data),
    forgotPassword: (data) => api.post('/auth/forgotpassword', data),
    resetPassword: (data) => api.post('/auth/resetpassword', data),
};

// Projects API
export const projectsAPI = {
    getAll: (params) => api.get('/projects', { params }),
    getById: (id) => api.get(`/projects/${id}`),
    create: (data) => api.post('/projects', data),
    update: (id, data) => api.put(`/projects/${id}`, data),
    delete: (id) => api.delete(`/projects/${id}`),
    getComments: (id) => api.get(`/projects/${id}/comments`),
    addComment: (id, comment) => api.post(`/projects/${id}/comments`, { comment }),
    uploadFile: (id, formData) => api.post(`/projects/${id}/files`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    }),
    deleteFile: (id, fileId) => api.delete(`/projects/${id}/files/${fileId}`),
};

// Tasks API
export const tasksAPI = {
    getAll: (params) => api.get('/tasks', { params }),
    getById: (id) => api.get(`/tasks/${id}`),
    create: (data) => api.post('/tasks', data),
    update: (id, data) => api.put(`/tasks/${id}`, data),
    delete: (id) => api.delete(`/tasks/${id}`),
    getComments: (id) => api.get(`/tasks/${id}/comments`),
    addComment: (id, comment) => api.post(`/tasks/${id}/comments`, { comment }),
    addSubtask: (id, data) => api.post(`/tasks/${id}/subtasks`, data),
    updateSubtask: (taskId, subtaskId, data) => api.put(`/tasks/${taskId}/subtasks/${subtaskId}`, data),
    deleteSubtask: (taskId, subtaskId) => api.delete(`/tasks/${taskId}/subtasks/${subtaskId}`),
    addDependency: (id, data) => api.post(`/tasks/${id}/dependencies`, data),
    deleteDependency: (taskId, dependencyId) => api.delete(`/tasks/${taskId}/dependencies/${dependencyId}`),
};

// Users API
export const usersAPI = {
    getAll: (params) => api.get('/users', { params }),
    getById: (id) => api.get(`/users/${id}`),
    create: (data) => api.post('/users', data),
    update: (id, data) => api.put(`/users/${id}`, data),
    delete: (id) => api.delete(`/users/${id}`),
};

// Notifications API
export const notificationsAPI = {
    getAll: (params) => api.get('/notifications', { params }),
    markAsRead: (id) => api.put(`/notifications/${id}/read`),
    markAllAsRead: () => api.put('/notifications/read-all'),
    delete: (id) => api.delete(`/notifications/${id}`),
};

// Reports API
export const reportsAPI = {
    getDashboard: () => api.get('/reports/dashboard'),
    getProjects: (params) => api.get('/reports/projects', { params }),
    getTasks: (params) => api.get('/reports/tasks', { params }),
    getUserReport: (id) => api.get(`/reports/users/${id}`),
};

// Analytics API
export const analyticsAPI = {
    getOverview: (params) => api.get('/analytics/overview', { params }),
    getUsersReport: (params) => api.get('/analytics/users', { params }),
    getProjectsReport: (params) => api.get('/analytics/projects', { params }),
    getTasksReport: (params) => api.get('/analytics/tasks', { params }),
};

// Calendar API
export const calendarAPI = {
    getEvents: (params) => api.get('/calendar', { params }),
};

// Tickets API
export const ticketsAPI = {
    getAll: (params) => api.get('/tickets', { params }),
    getById: (id) => api.get(`/tickets/${id}`),
    create: (data) => api.post('/tickets', data),
    update: (id, data) => api.put(`/tickets/${id}`, data),
    delete: (id) => api.delete(`/tickets/${id}`),
    addComment: (id, comment) => api.post(`/tickets/${id}/comments`, { comment }),
};

// Excom API
export const excomAPI = {
    getAllMeetings: (params) => api.get('/excom/meetings', { params }),
    getMeetingDetail: (id) => api.get(`/excom/meetings/${id}`),
    createMeeting: (data) => api.post('/excom/meetings', data),
    updateMeeting: (id, data) => api.put(`/excom/meetings/${id}`, data),
    deleteMeeting: (id) => api.delete(`/excom/meetings/${id}`),
    getOpenActions: () => api.get('/excom/actions/open'),
};

// ICT Meetings API
export const meetingsAPI = {
    getAll: (params) => api.get('/meetings', { params }),
    getById: (id) => api.get(`/meetings/${id}`),
    create: (data) => api.post('/meetings', data),
    update: (id, data) => api.put(`/meetings/${id}`, data),
    delete: (id) => api.delete(`/meetings/${id}`),
};


// ICT Governance Hub API
export const governanceAPI = {
    getForms: () => api.get('/governance/forms'),
    getSummary: () => api.get('/governance/summary'),
    getRecords: (params) => api.get('/governance/records', { params }),
    getRecord: (id) => api.get(`/governance/records/${id}`),
    createRecord: (data) => api.post('/governance/records', data),
    updateRecord: (id, data) => api.put(`/governance/records/${id}`, data),
    deleteRecord: (id) => api.delete(`/governance/records/${id}`),
    decideApproval: (id, data) => api.put(`/governance/approvals/${id}`, data),
    getActions: (params) => api.get('/governance/actions', { params }),
    updateAction: (id, data) => api.put(`/governance/actions/${id}`, data),
};
